var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.507 3.578l2 2M2.507 13.578h11M10.129 2.131a.4.4 0 01.565 0l1.687 1.687a.4.4 0 010 .566l-6.765 6.765a.4.4 0 01-.269.117l.021.6-.02-.6-2.176.074.075-2.175-.6-.02.6.02a.4.4 0 01.117-.269l6.764-6.765z",
    stroke: "#3C3F47",
    strokeWidth: 1.2
  })));
}
export default __webpack_public_path__ + "static/rename.b442195b.svg";
export { SvgRename as ReactComponent };